<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-date-picker
                    class="mr10"
                    v-model="date_value"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                    >
                </el-date-picker>
                <el-select v-model="date_id" class="handle-select mr10" @change="selectStatisticsHandle">
                    <el-option
                      v-for="(child, index) in date_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-select v-model="provider_id" class="handle-select" @change="selectProviderHandle">
                    <el-option
                      v-for="(child, index) in providers"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
            </div>
            <div id="order_cavans" style="width: 100%;height:600px;margin-bottom: 20px;" v-loading="order_loading"></div>
            <div class="handle-box">

                <label>订单状态：</label>
                <el-select v-model="status_id" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in order_status"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-input v-model="keyword" placeholder="请输入订单编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button
                type="primary"
                icon="el-icon-lx-down"
                class="handle-down"
                @click="handleExport"
                >批量导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="out_trade_no" label="订单编号" align="center"></el-table-column>
                <el-table-column prop="prescription_num" label="处方号" align="center"></el-table-column>
                <el-table-column prop="provider_name" label="药房" align="center"></el-table-column>
                <el-table-column prop="addressee" label="收件人" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column label="总金额(元)" align="center">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.price)}}
                    </template>
                </el-table-column>
                <el-table-column label="邮费(元)" align="center">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.postage)}}
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" align="center">
                    <template slot-scope="scope">
                        {{getIdName(order_status, scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.created_time)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleLook(scope.row)"
                        >详情</el-button>
                        <el-button
                            type="text"
                            @click="handleEdit(scope.row)"
                        >编辑处方号</el-button>
                        <el-button
                            type="text"
                            @click="handleExamine(true, scope.row)"
                            v-if="scope.row.status == 1"
                        >通过审核</el-button>
                        <el-button
                            type="text"
                            @click="handleExamine(false, scope.row)"
                            v-if="scope.row.status == 1"
                        >拒单</el-button>
                        <el-button
                            type="text"
                            @click="handleExpress(scope.row)"
                            v-if="scope.row.status == 2"
                        >发货</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="examineVisible" width="60%" :close-on-click-modal="false">
            <el-form ref="examineRuleForm" :model="examine_form" :rules="examine_rules" label-width="160px">
                <el-form-item label="订单编号：">
                    <span class="fc">{{examine_form.out_trade_no}}</span>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input
                     v-model="examine_form.remark" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveExamine('examineRuleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="expressVisible" width="60%" :close-on-click-modal="false">
            <el-form ref="expressRuleForm" :model="express_form" :rules="express_rules" label-width="160px">
                <el-form-item label="订单编号：">
                    <span class="fc">{{express_form.out_trade_no}}</span>
                </el-form-item>
                <el-form-item label="快递商：" prop="express_name">
                    <el-input
                     v-model="express_form.express_name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="快递号：" prop="express_no">
                    <el-input
                     v-model="express_form.express_no" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveExpress('expressRuleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="editVisible" width="60%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
                <el-form-item label="订单编号：">
                    <span class="fc">{{form.out_trade_no}}</span>
                </el-form-item>
                <el-form-item label="处方号：" prop="prescription_num">
                    <el-input
                     v-model="form.prescription_num" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="lookVisible" width="60%" :close-on-click-modal="false">
            <el-form :model="detail" label-width="160px">
                <el-form-item label="订单编号：">
                    <span class="fc">{{detail.out_trade_no}}</span>
                </el-form-item>
                <el-form-item label="处方号：">
                    <span class="fc">{{detail.prescription_num}}</span>
                </el-form-item>
                <el-form-item label="订单状态：">
                    <span class="fc">{{getIdName(order_status, detail.status)}}</span>
                </el-form-item>
                <el-form-item label="下单时间：">
                    <span class="fc">{{formatDate(detail.order_time)}}</span>
                </el-form-item>
                <el-form-item label="收件人：">
                    <span class="fc">{{detail.addressee}}</span>
                </el-form-item>
                <el-form-item label="手机号：">
                    <span class="fc">{{detail.phone}}</span>
                </el-form-item>
                <el-form-item label="收货地址：">
                    <span class="fc">{{detail.address}}</span>
                </el-form-item>
                <el-form-item label="药价(元)：">
                    <span class="fc">{{formatPrice(detail.drug_price)}}</span>
                </el-form-item>
                <el-form-item label="邮费(元)：">
                    <span class="fc">{{formatPrice(detail.postage)}}</span>
                </el-form-item>
                <el-form-item label="总金额(元)：">
                    <span class="fc">{{formatPrice(detail.total_count)}}</span>
                </el-form-item>
                <el-form-item label="快递商：" v-if="detail.express_name">
                    <span class="fc">{{detail.express_name}}</span>
                </el-form-item>
                <el-form-item label="快递号：" v-if="detail.express_no">
                    <span class="fc">{{detail.express_no}}</span>
                </el-form-item>
                <el-form-item label="医生姓名：">
                    <span class="fc">{{detail.doctor_name}}</span>
                </el-form-item>
                <el-form-item label="患者姓名：">
                    <span class="fc">{{detail.patient_name}}</span>
                </el-form-item>
                <el-form-item label="患者性别：">
                    <span class="fc">{{getSex(detail.patient_sex)}}</span>
                </el-form-item>
                <el-form-item label="患者年龄：">
                    <span class="fc">{{detail.patient_age}}岁</span>
                </el-form-item>
                <el-form-item label="处方：">
                    <span class="fc">{{getJson(detail.prescription)}}</span>
                </el-form-item>
                <el-form-item label="用法：">
                    <span class="fc">{{getUsage(detail.usage)}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="closeLook">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import echarts from "echarts";
import {_} from 'vue-underscore';
const { export_json_to_excel } = require("../../../utils/Export2Excel.js");
import http from '../../../api/pontusApiConfig'
import http2 from '../../../api/dorisApiConfig'
export default {
    name: 'prescriptionlist',
    data() {
        return {
            order_loading: false,
            date_value: [],
            date_types: [
                {"name": "按天", "id": 'day'},
                {"name": "按周", "id": 'week'},
                {"name": "按月", "id": 'month'}
            ],
            date_id: 'day',
            statistics: [],
            dateStatistics: [],
            keyword: '',
            providers: [],
            provider_id: 2,
            order_status: [
                {"name": "全部", "id": ''},
                {"name": "失败", "id": -1},
                {"name": "超时", "id": -2},
                {"name": "待支付", "id": 0},
                {"name": "已支付", "id": 1},
                {"name": "药房已接单", "id": 2},
                {"name": "配送中", "id": 3},
                {"name": "已签收/已完成", "id": 4},
                {"name": "已退款(药房退单)", "id": 5},
                {"name": "已退款(系统退单)", "id": 6},
                {"name": "已取消(超时未支付)", "id": 7}
            ],
            status_id: '',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            loading: false,
            lookVisible: false,
            editVisible: false,
            detail: {},
            form: {},
            rules: {
                prescription_num: [{ required: true, message: "请填写处方号", trigger: "blur" }]
            },
            examineVisible: false,
            examine_form: {},
            examine_rules: {
                remark: [{ required: true, message: "请填写备注", trigger: "blur" }]
            },
            expressVisible: false,
            express_form: {},
            express_rules: {
                express_name: [{ required: true, message: "请填写快递商", trigger: "blur" }],
                express_no: [{ required: true, message: "请填写快递号", trigger: "blur" }]
            }
        };
    },
    created() {
        this.date_value.push("2020-01-01");
        this.date_value.push(new Date().Format('YYYY-MM-DD'));
        let that = this;
        http2.get("/admin/providers",{params: {page: 1, page_size: 20}}).then(function(res) {
            that.providers = that.providers.concat(res.data.data.providers);
        });
        this.getData();
    },
    mounted() {
        this.getStatisticsData();
    },
    methods: {
        handleExport(){
            let that = this;
            if(that.totalPages === 1){
                let list = []
                that.tableData.forEach((item, index) => {
                    list.push({
                        out_trade_no: item['out_trade_no'],
                        provider_name: item['provider_name'],
                        addressee: item['addressee'],
                        phone: item['phone'],
                        price: that.formatPrice(item['price']),
                        postage: that.formatPrice(item['postage']),
                        status: that.getIdName(that.order_status, item['status']),
                        created_time: that.formatDate(item['created_time'])
                    })
                });
                that.export(list);
            }else{
                that.exportList();
            }
        },
        exportList(){
            let that = this;
            let params = {
                page: 1,
                page_size: that.totalPages * that.page_size
            }
            if(that.keyword){
                params["out_trade_no"] = that.keyword;
            }
            if(that.provider_id){
                params["provider_id"] = that.provider_id;
            }
            if(that.status_id){
                params["status"] = that.status_id;
            }
            http.get("/admin/medshop/orders",{params: params}).then(function(res) {
                let list = [];
                res.data.data.orders.forEach((item, index) => {
                    list.push({
                        out_trade_no: item['out_trade_no'],
                        provider_name: item['provider_name'],
                        addressee: item['addressee'],
                        phone: item['phone'],
                        price: that.formatPrice(item['price']),
                        postage: that.formatPrice(item['postage']),
                        status: that.getIdName(that.order_status, item['status']),
                        created_time: that.formatDate(item['created_time'])
                    })
                });
                that.export(list);
            });
        },
        export(res){
            let that = this;
            require.ensure([], () => {
                const tHeader = [
                    "订单编号",
                    "药房",
                    "收件人",
                    "手机号",
                    "总金额(元)",
                    "邮费(元)",
                    "订单状态",
                    "下单时间"
                ];
                const filterVal = [
                    "out_trade_no",
                    "provider_name",
                    "addressee",
                    "phone",
                    "price",
                    "postage",
                    "status",
                    "created_time"
                ];
                const data = this.formatJson(filterVal, res);
                export_json_to_excel(tHeader, data, "药房订单列表");
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        drawOrderChart(){
            let that = this;
            let myChart = echarts.init(document.getElementById("order_cavans"));
            let option = {
                title: {
                    text: '药房订单统计'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['药房订单']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: that.dateStatistics
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '药房订单',
                        type: 'line',
                        data: that.statistics
                    }
                ]
            };
            myChart.setOption(option);
            window.onresize=function(){
                myChart.resize();
            }
        },
        selectStatisticsHandle(){
            this.getStatisticsData();
        },
        selectProviderHandle(){
            this.getStatisticsData();
            this.currentPage = 1;
            this.getData();
        },
        dateChange(e){
            this.getStatisticsData();
        },
        getStatisticsData() {
            let that = this;
            that.order_loading = true;
            let params = {
                provider_id: that.provider_id,
                type: that.date_id,
                start_time: that.date_value[0],
                end_time: that.date_value[1]
            }
            http.get("/admin/medshop/statistics/order",{params: params}).then(function(res) {
                that.statistics = [];
                that.dateStatistics = [];
                res.data.data.forEach((item, index) => {
                    that.statistics.push(item['order_count']);
                    that.dateStatistics.push(item['date']);
                });
                that.drawOrderChart();
                that.order_loading = false;
            });
        },
        getSex(id){
            if(id === 0){
                return '女';
            }else if(id === 1){
                return '男';
            }else{
                return '';
            }
        },
        getUsage(id){
            if(id === 1){
                return '内服';
            }else if(id === 2){
                return '外用';
            }else{
                return '';
            }
        },
        getJson(json){
            if(json){
                json = JSON.parse(json);
                let str = '';
                json.forEach((item, index) => {
                    if(index == 0){
                        str = item['name'] + item['count'] + item['unit'];
                    }else{
                        str += '，' + item['name'] + item['count'] + item['unit'];
                    }
                });
                return str;
            }else{
                return '';
            }
        },
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        formatPrice(price){
            return price/100;
        },
        getIdName(list, id){
            let item = _.filter(list, function(selector){ return selector.id == id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.keyword){
                params["out_trade_no"] = that.keyword;
            }
            if(that.provider_id){
                params["provider_id"] = that.provider_id;
            }
          console.log(that.status_id);
          if(that.status_id !='' || that.status_id== 0){
                params["status"] = that.status_id;
            }
            http.get("/admin/medshop/orders",{params: params}).then(function(res) {
                that.tableData = res.data.data.orders;
                that.currentPage = parseInt(res.data.data.current_page);
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        onInput(){
            this.$forceUpdate();
        },
        handleLook(row){
            this.detail = row;
            let that = this;
            let params = {
                out_trade_no: row.out_trade_no
            }
            http.get("/admin/medshop/order",{params: params}).then(function(res) {
                that.detail = res.data.data;
                that.lookVisible = true;
            });
        },
        closeLook(){
            this.lookVisible = false;
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        },
        handleExamine(adopt, row){
            if(adopt){
                let that = this;
                let params = {
                    out_trade_no: row.out_trade_no
                }
                http.post("/admin/medshop/approved", params).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.currentPage = 1;
                        that.getData();
                    }else{
                        that.$error.success(res.data.msg);
                    }
                });
            }else{
                this.examine_form = {
                    out_trade_no: row.out_trade_no
                }
                this.examineVisible = true;
            }
        },
        saveExamine(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        out_trade_no: that.form.out_trade_no,
                        prescription_num: that.form.prescription_num
                    }
                    http.post("/admin/medshop/rejection", params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.currentPage = 1;
                            that.getData();
                        }else{
                            that.$error.success(res.data.msg);
                        }
                    });
                    that.examineVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleExpress(row){
            this.express_form = {
                out_trade_no: row.out_trade_no
            }
            this.expressVisible = true;
        },
        saveExpress(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        out_trade_no: that.express_form.out_trade_no,
                        express_name: that.express_form.express_name,
                        express_no: that.express_form.express_no
                    }
                    http.post("/admin/medshop/deal_express", params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.currentPage = 1;
                            that.getData();
                        }else{
                            that.$error.success(res.data.msg);
                        }
                    });
                    that.expressVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleEdit(row){
            this.form = {
                out_trade_no: row.out_trade_no,
                prescription_num: row.prescription_num
            }
            this.editVisible = true;
        },
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        out_trade_no: that.form.out_trade_no,
                        prescription_num: that.form.prescription_num
                    }
                    http.post("/admin/medshop/prescription/num", params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.currentPage = 1;
                            that.getData();
                        }else{
                            that.$error.success(res.data.msg);
                        }
                    });
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss" type="text/css" scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.clearfix:after{content:"";display:block;height:0;clear:both;visibility:hidden;}
.fl{float:left;display:inline;}
.fr{float:right;display:inline;}
.medicines-ul{
    margin-top: 5px;
}
.medicines-ul .li,
.select-medicines-ul li{
    list-style-type: none;
}
.medicines-li{
    margin-right: 5px;
    margin-bottom: 5px;
    display: block;
    max-width: 100%;
    height: 30px;
    line-height: 20px;
    box-sizing: border-box;
    color: #333;
    text-align: center;
    font-size: 14px;
    padding: 5px;
    border: 1px solid #eee;
    border-radius: 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
}
.select-medicines-ul{
    width: 100%;
    min-height: 200px;
}
.select-medicines-li{
    margin-top: 10px;
    width: 33.333333%;
    box-sizing: border-box;
    padding-left: 25px;
    padding-right: 100px;
    position: relative;
}
.delete-medicine{
    width: 20px;
    height: 20px;
    padding: 3px;
    margin: auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
}
.medicine-name{
    display: block;
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.medicine-input{
    width: 50px;
    height: 32px;
    line-height: 32px;
    display: block;
    text-align: center;
    position: absolute;
    right: 50px;
    top: 0;
}
.medicine-input .el-input__inner{
    text-align: center;
}
.medicine-unit{
    display: block;
    height: 32px;
    line-height: 32px;
    position: absolute;
    right: 30px;
    top: 0;
}
</style>
